import {push} from "react-router-redux";
import { store } from '../redux/store';

class QueryParam {

  dispatchLocationChange = location => store.dispatch(push(location));

  setParams(params, location = window.location.pathname, keepOldParams = true) {
    const new_params = keepOldParams
      ? window.location.search
              .substring(1)
              .split('&')
              .map((value) => {
                const pair = value.split('=');
                return {
                  key: pair[0],
                  value: pair[1]
                };
              })
              .filter( v => v.key )
      : [];

    params.forEach( p => {
      const exists = params.find( value => {
        return value.key === p.key;
      });

      if(exists){
        exists.value = p.value;
      } else {
        new_params.push({
          key: p.key,
          value: p.value
        });
      }
    });

    let search_str = params
      .map( o => o.key + "=" + o.value )
      .join('&');

    if(search_str.length > 0)
      search_str = '?' + search_str;

    this.dispatchLocationChange(location + search_str);
  }

  getParam(key) {
    const param = this.props.location.search
      .substring(1)
      .split('&')
      .map((value) => {
        const pair = value.split('=');
        return {
          key: pair[0],
          value: pair[1]
        };
      })
      .find((value) => {
        return value.key === key;
      });

    return param && param.value;
  }

  changeLocation(location,params,keepOldParams){
    this.setParams(params,location,keepOldParams);
  }

}

export const queryParam = new QueryParam();



// WEBPACK FOOTER //
// ./src/util/QueryParam.js